// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__E8DBT","label":"SetPasswdForm_label__cEyvs"};